import type { ElementPosition } from '../layout/section/types';
import type { ParsedElementType, ParsedStructuredElementType } from '../layout/types';

/**
 * Get elements for a specific position, filtering out string elements
 */
export const getElementsForPosition = (
	elements: ParsedElementType[],
	position: ElementPosition,
	defaultIndex: number,
): ParsedStructuredElementType[] => {
	const result: ParsedStructuredElementType[] = [];

	for (let i = 0; i < elements.length; i++) {
		const element = elements[i];
		if (typeof element === 'string') {
			continue;
		}
		if (element.attributes?.pos === position || (i === defaultIndex && !element.attributes?.pos)) {
			result.push(element);
		}
	}

	return result;
};
